import { render, staticRenderFns } from "./AssessmentRetake.vue?vue&type=template&id=0bb94634"
import script from "./AssessmentRetake.vue?vue&type=script&lang=js"
export * from "./AssessmentRetake.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRetake.vue?vue&type=style&index=0&id=0bb94634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports